interface SharepointIconProps {
  size?: string | number
  className?: string
}

export const SharepointIcon: React.FC<SharepointIconProps> = ({
  size = 24,
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={Number(size)}
    height={Number(size)}
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    aria-label="SharePoint logo"
    className={className}
  >
    <circle cx="10.5" cy="7.5" r="6" fill="#036C70" />
    <circle cx="15" cy="13.5" r="5.25" fill="#1A9BA1" />
    <circle cx="11.25" cy="18" r="4.5" fill="#37C6D0" />
    <rect x="3" y="5.25" width="10.5" height="13.5" rx="1.5" fill="#03787C" />
    <text
      x="8.25"
      y="14.25"
      textAnchor="middle"
      fill="white"
      fontSize="7.5"
      fontWeight="600"
      fontFamily="Arial, sans-serif"
    >
      S
    </text>
  </svg>
)
